module.exports = __webpack_public_path__ + "media/images/career_camp/2022/home_ruins_2-e67271047ee9134da9e4401ec94e3b21.svg";